export default __webpack_public_path__ + "static/media/IMG_5578.c19da98a.jpg";